import { statsigCohortParser } from "./cohort-parsers/statsig";
export function retrieveBootstrapCohorts(window, config) {
    if (!config.windowGetters) {
        return;
    }
    const userCohorts = {};
    config.windowGetters.forEach(({ key, paths }) => {
        const value = getValueFromWindow(window, paths);
        if (value) {
            userCohorts[key] = value;
        }
    });
    if (Object.keys(userCohorts).length === 0) {
        return;
    }
    return userCohorts;
}
function getValueFromWindow(window, paths) {
    // Guard against ssr
    if (typeof window === "undefined") {
        return;
    }
    //biome-ignore lint/suspicious/noExplicitAny: We need to use any here to access the window object
    let obj = window;
    for (let i = 0; i < paths.length - 1; i++) {
        obj = obj[paths[i]];
        if (typeof obj !== "object") {
            return;
        }
    }
    const value = obj[paths[paths.length - 1]];
    if (typeof value === "string") {
        return value;
    }
    if (typeof value === "boolean" || typeof value === "number") {
        return value.toString();
    }
}
export function getAutoCohorts(window) {
    return statsigCohortParser(window);
}
